window.SYN_KNOWLEDGE = {
  services: {
    website: {
      triggers: ["website", "site", "web design", "landing page"],
      reply: "SYN builds professional websites with strategy, design, mobile responsiveness, copy direction, SEO setup and launch support. A single landing page starts from £70, and a full multi-page website starts from £150."
    },
    shopify: {
      triggers: ["shopify", "store", "ecommerce", "online shop"],
      reply: "SYN builds Shopify stores with setup, homepage design, product structure, collections, branding, checkout flow and conversion-focused layouts. Pricing follows our standard website tiers, from £150 for a full build up to £599 for an advanced custom build."
    },
    branding: {
      triggers: ["branding", "brand", "logo", "identity"],
      reply: "Brand basics (logo direction, colour palette, typography) are included as part of our Startup Launch Package, which starts from £249."
    },
    automation: {
      triggers: ["automation", "ai", "chatgpt", "workflow", "system"],
      reply: "SYN can help businesses save time with AI tools, workflow automation, enquiry systems, quote forms and digital business systems."
    },
    pricing: {
      triggers: ["price", "pricing", "cost", "quote", "budget"],
      reply: "Landing pages start from £70, full websites from £150, Startup Launch Packages (site + brand + SEO) from £249, and ongoing SEO or marketing support from £99/month. Flexible partnerships may be considered for selected projects."
    },
    partnership: {
      triggers: ["partnership", "revenue", "equity", "shares", "percentage"],
      reply: "SYN may consider selected revenue-share or strategic equity partnerships. These are reviewed individually and require proper written agreement and due diligence."
    }
  },

  fallback:
    "That sounds like something SYN can help with. Use the project enquiry form at /pages/contact to send your business stage, budget and timeline, and we\u2019ll guide you towards the best next step."
};